import { endpoints as commonEndpoints } from './endpoints';
import { formats as commonFormats } from './formats';
import { info as commonInfo } from './info';
import { settings as commonSettings } from './settings';

export const environment = {
  production: true,
  name: 'RELEASE',
} as const;

export const settings = {
  ...commonSettings,
  i18nCache: true,
} as const;

export const formats = {
  ...commonFormats,
} as const;

export const endpoints = {
  ...commonEndpoints,
} as const;

export const credentials = {
  username: '',
  password: '',
} as const;

export const info = {
  ...commonInfo,
} as const;
